export type LineItemQtyInput = {
  quantity: number;
  unit?: string | null;
};

export type QtyByUnitRow = {
  unit: string;
  quantity: number;
};

const EMPTY_UNIT_LABEL = "—";

/** ລວມ qty ຕາມຫນ່ວຍ — ໃຊ້ສະແດງພາຍໃນເທົ່ານັ້ນ (ບໍ່ພິມໃນເອກະສານ) */
export function computeLineItemsQtyByUnit(
  items: LineItemQtyInput[],
): QtyByUnitRow[] {
  const totals = new Map<string, number>();

  for (const item of items) {
    const qty = Number(item.quantity);
    if (!Number.isFinite(qty) || qty <= 0) continue;
    const unit = item.unit?.trim() || EMPTY_UNIT_LABEL;
    totals.set(unit, (totals.get(unit) ?? 0) + qty);
  }

  return [...totals.entries()]
    .map(([unit, quantity]) => ({ unit, quantity }))
    .sort((a, b) => a.unit.localeCompare(b.unit, "lo"));
}
